import type { Controller } from "@hotwired/stimulus";
import { getApplication } from "./get_application";

export function getController<T = Controller<Element>>(controllerName: string) {
  const selector = `[data-controller*="${controllerName}"]`;
  const elements = document.querySelectorAll(selector);

  if (elements.length === 0) {
    throw new Error(`Controller element not found for selector: ${selector}`);
  }

  const application = getApplication();
  const controllers: Controller[] = [];

  for (const element of elements) {
    const foundController = application.getControllerForElementAndIdentifier(
      element,
      controllerName
    );

    if (foundController) {
      controllers.push(foundController);
    }
  }

  if (!controllers.length) {
    throw new Error(`Controller not found for identifier: ${controllerName}`);
  }

  if (controllers.length > 1) {
    throw new Error(
      `Multiple controllers found for identifier: ${controllerName}`
    );
  }

  return controllers[0] as T;
}
